import React from 'react';
interface LogoProps {
  tone?: 'dark' | 'light';
}
export function Logo({
  tone = 'dark'
}: LogoProps) {
  const text = tone === 'dark' ? 'text-ink' : 'text-canvas';
  return <span className={`inline-flex items-center gap-2.5 ${text}`} data-id="element-354" data-mp="tbtc2ig8m96h">
      <svg width="30" height="30" viewBox="0 0 30 30" aria-hidden="true" data-id="element-355" data-mp="t9yrx6csil3g">
        <rect width="30" height="30" rx="8" className={tone === 'dark' ? 'fill-forest' : 'fill-canvas'} data-id="element-356" data-mp="obx82j7jihqx" />
        <rect x="8" y="7" width="14" height="4" rx="1.5" className="fill-volt" data-id="element-357" data-mp="kbwuf0s9makx" />
        <rect x="8" y="13" width="14" height="4" rx="1.5" className="fill-volt" opacity="0.7" data-id="element-358" data-mp="fk54msgxo8vu" />
        <rect x="8" y="19" width="14" height="4" rx="1.5" className="fill-volt" opacity="0.4" data-id="element-359" data-mp="akir0hx70qmi" />
      </svg>
      <span className="text-[19px] font-semibold tracking-tight" data-id="element-360" data-mp="5na300pd5sdc">Stroomkluis</span>
    </span>;
}